import { useTranslation } from "react-i18next";

import play3 from "../../../assets/images/shared/play-3.svg";
import thumbnail from "../../../assets/images/story/thumbnail.png";
import arrow from "../../../assets/images/story/arrow.png";
import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";
import cn from "../../../utils/cn";

const variants = {
  mobile: {
    wrap: "flex h-fit w-full gap-0.5",
    thumb: "w-[171px]",
    play: "size-9",
    tipWrap: "relative left-0 top-[26px] flex h-fit flex-1 items-center",
    tipBox: "h-fit w-full rounded-lg bg-white px-3 py-4 shadow-custom0",
  },
  tablet: {
    wrap: "flex h-fit w-full gap-3",
    thumb: "w-[236px]",
    play: "size-12",
    tipWrap: "relative top-[60px] mr-6 h-fit flex min-w-0 flex-1 items-center",
    tipBox:
      "w-full rounded-lg bg-white px-3 py-4 shadow-custom0 min-[612px]:w-[320px]",
  },
};

export default function StoryVideoHint({
  variant,
  onPlay,
}: {
  variant: "mobile" | "tablet";
  onPlay: () => void;
}) {
  const { t } = useTranslation();
  const styles = variants[variant];

  return (
    <div className={styles.wrap}>
      <div className={cn("h-fit", styles.thumb)}>
        <Touchable
          className={cn(
            "relative overflow-hidden rounded-lg shadow-custom0",
            styles.thumb,
          )}
          onClick={onPlay}
        >
          <img src={thumbnail} alt="thumbnail" />

          <img
            src={play3}
            alt="play3"
            className={cn("absolute bottom-1.5 right-1.5 z-[2]", styles.play)}
          />
        </Touchable>

        <Text normal className="mt-2">
          Straight Play 4
        </Text>
      </div>

      <div className={styles.tipWrap}>
        <img src={arrow} alt="arrow" className="relative z-[1] w-2 shrink-0" />

        <div className={styles.tipBox}>
          <Text normal className="text-blue">
            {t("storyVideoDescription")}
          </Text>
        </div>
      </div>
    </div>
  );
}
